import React, { useEffect } from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Benefits from '../components/Benefits';
import Services from '../components/Services';


const Layanan = () => {
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <>
            <Services />
            <Clients />
            <Benefits />
            <Footer />
        </>

    )
}

export default Layanan;

